import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import IconButton from '@material-ui/core/IconButton';
import { Grid } from '@material-ui/core';
import Person from '@material-ui/icons/Person';
import Group from '@material-ui/icons/Group';
import Public from '@material-ui/icons/Public';
import '../CompanySignUp.css';
import Button from '@material-ui/core/Button';
import HpTooltip from '../../../../components/shared/components/hpTooltip';

const StyledButton = withStyles({
  root: {
    background: '#5DBE76',
    color: 'white',
    boxShadow: '0 0 5px 2px gray'
  }
})(IconButton);

const styles = theme => ({
  listItem: {
    padding: `${theme.spacing.unit}px 0`
  },
  total: {
    fontWeight: '700'
  },
  title: {
    marginTop: theme.spacing.unit * 2
  },
  iconItem: {
    backgroundColor: 'green',
    color: 'green'
  },
  buttons: {
    display: 'flex',
    justifyContent: 'center',
    marginTop: '40px'
  },
  nextButton: {
    marginTop: theme.spacing.unit * 3,
    color: '#ffffff',
    paddingLeft: 50,
    paddingRight: 50
  },
  backButton: {
    marginTop: theme.spacing.unit * 3,
    marginRight: theme.spacing.unit,
    color: '#000000',
    paddingLeft: 50,
    paddingRight: 50
  },
  titleContainer: {
    textAlign: 'center'
  }
});

class InfluenceLevel extends React.Component {
  constructor() {
    super();

    this.initialState = {
      submitAttempted: false
    };

    this.state = {
      ...this.initialState
    };
  }

  render() {
    const {
      classes,
      companyInfo,
      changeHandler,
      handleBack,
      handleFinish
    } = this.props;
    return (
      <React.Fragment>
        <Grid container direction="column" spacing={24}>
          <Grid
            container
            align="center"
            justify="center"
            onClick={() => changeHandler('small')}
          >
            <StyledButton>
              <Person />
            </StyledButton>
            <span
              className={`icon-button-div ${
                companyInfo.levelOfInfluence === 'small'
                  ? 'icon-button-div-selected'
                  : ''
              }`}
            >
              100 to 10,000 followers
            </span>
          </Grid>
          <Grid
            container
            align="center"
            justify="center"
            onClick={() => changeHandler('medium')}
            className="levelItem"
          >
            <StyledButton>
              <Group />
            </StyledButton>
            <span
              className={`icon-button-div ${
                companyInfo.levelOfInfluence === 'medium'
                  ? 'icon-button-div-selected'
                  : ''
              }`}
            >
              10,000 to 100,000 followers
            </span>
          </Grid>
          <Grid
            container
            align="center"
            justify="center"
            onClick={() => changeHandler('large')}
            className="levelItem"
          >
            <StyledButton>
              <Public />
            </StyledButton>
            <span
              className={`icon-button-div ${
                companyInfo.levelOfInfluence === 'large'
                  ? 'icon-button-div-selected'
                  : ''
              }`}
            >
              100,000 or more followers
            </span>
          </Grid>
          <Grid xs={12} className="levelItem">
            <Grid container spacing={1} justify="center">
              <Grid item>
                <Typography align="center">
                  Reade more about influencer
                </Typography>
              </Grid>
              <Grid item>
                <Typography color="primary">Here</Typography>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        <div className={classes.buttons}>
          <Button onClick={handleBack} className={classes.backButton}>
            Back
          </Button>
          <Button
            variant="contained"
            color="primary"
            onClick={() => handleFinish()}
            className={classes.nextButton}
          >
            Finish
          </Button>
        </div>
      </React.Fragment>
    );
  }
}

export default withStyles(styles)(InfluenceLevel);



// WEBPACK FOOTER //
// ./src/components/sign-up/company/components/InfluenceLevel.js